export const HTTP_HEADERS = {
  AWS_WAF: 'x-amzn-waf-action'
} as const;
